import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyFruityIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./FruityIcon-e3d81140.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyFruityIcon as P };
